import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const ModifierPageRBAC = {
  pageID: '06a56b78dd50f19b5a5410d849771121',
  elementID: {
    BtnAddModifier: 'eaae1372f09c371a24ccd4d4927074ab',
    BtnEditModifier: 'c66c1558761fb490acdf6dc86c7fc848',
  },
} as const

export const useRBACModifierPage = createUseRBAC(ModifierPageRBAC.elementID)

export type UseRBACModifierPageType = ReturnType<typeof useRBACModifierPage>
